import { CalendarDays, Check, ChevronDown } from 'lucide-react'
import { Menu, Switch } from '../common'
import { RANGE_PRESETS, rangeLabelFor } from './dashboardFilters'
import { DateRangePicker } from './DateRangePicker'
import { showsStatePicker } from './stateFilter'
import { StatePicker } from './StatePicker'
import styles from './DashboardFilterControls.module.css'

// The range, state and comparison controls, shared by the dashboard toolbar
// and the expanded widget header so both always show the same period and
// states. `states` is the brand's list, null where the page doesn't take
// states; the picker shows when there is a choice.
export function DashboardFilterControls({ filters, onChange, states = null, compact = false }) {
  const isCustom = filters.preset === 'custom'
  return (
    <div className={`${styles.controls} ${compact ? styles.compact : ''}`.trim()}>
      <Menu
        align="start"
        triggerLabel="Date range"
        trigger={(
          <button type="button" className={styles.trigger} aria-label={`Date range: ${rangeLabelFor(filters)}`}>
            <CalendarDays size={16} aria-hidden="true" />
            <span className={styles.triggerLabel}>{rangeLabelFor(filters)}</span>
            <ChevronDown size={16} aria-hidden="true" />
          </button>
        )}
        items={RANGE_PRESETS.map((preset) => ({
          key: preset.key,
          label: preset.label,
          icon: filters.preset === preset.key ? Check : undefined,
          selected: filters.preset === preset.key,
          onSelect: () => onChange({ preset: preset.key }),
        }))}
      />
      {isCustom ? (
        <DateRangePicker
          compact={compact}
          start={filters.customStart}
          end={filters.customEnd}
          onChange={({ start, end }) => onChange({ customStart: start, customEnd: end })}
        />
      ) : null}
      {states && showsStatePicker(states, filters.states) ? (
        <StatePicker states={states} picked={filters.states} onChange={(next) => onChange({ states: next })} compact={compact} />
      ) : null}
      {/* Short on screen, beside the range it compares; the full phrase is
          its name and its tooltip. */}
      <Switch
        size="compact"
        checked={filters.compare}
        onChange={(checked) => onChange({ compare: checked })}
        label="Compare"
        aria-label="Compare with previous period"
        title="Compare with the previous period of the same length"
        className={styles.compare}
      />
    </div>
  )
}
